import { render, staticRenderFns } from "./CanShipToCampus.vue?vue&type=template&id=918da604&scoped=true"
import script from "./CanShipToCampus.vue?vue&type=script&lang=js"
export * from "./CanShipToCampus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918da604",
  null
  
)

export default component.exports